module.exports = __webpack_public_path__ + "static/img/1a.a7f245c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/1a.jpg
// module id = Ipue
// module chunks = 0